import { ItProgram } from 'screens/it-program';

export default ItProgram;
